module.exports = __webpack_public_path__ + "static/img/group-icon.50a18785.svg";